/**
 * Про товар: акордеон на мобільному, таби на десктопі.
 * Одна розмітка (.about-item = заголовок + панель), дві поведінки.
 * Без jQuery. Замінює собою tabsInit() для блоку .about-wrapper.
 */
(function () {
  const DESKTOP = window.matchMedia("(min-width: 750px)");

  function setOpen(item, open) {
    item.classList.toggle("is-open", open);
    const trigger = item.querySelector(".about-item__trigger");
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.aboutInit === "true") return;
    wrapper.dataset.aboutInit = "true";

    const items = Array.from(wrapper.querySelectorAll(".about-item"));
    if (!items.length) return;

    const ensureOne = function () {
      const anyOpen = items.some(function (item) {
        return item.classList.contains("is-open");
      });
      if (!anyOpen) setOpen(items[0], true);
    };

    items.forEach(function (item) {
      const trigger = item.querySelector(".about-item__trigger");
      if (!trigger) return;

      trigger.addEventListener("click", function () {
        const wasOpen = item.classList.contains("is-open");

        // На десктопі це таби: активний таб не закривається кліком по собі
        if (wasOpen && DESKTOP.matches) return;

        items.forEach(function (other) {
          if (other !== item) setOpen(other, false);
        });
        setOpen(item, !wasOpen);
      });
    });

    const onBreakpointChange = function () {
      if (DESKTOP.matches) ensureOne();
    };

    if (typeof DESKTOP.addEventListener === "function") {
      DESKTOP.addEventListener("change", onBreakpointChange);
    } else if (typeof DESKTOP.addListener === "function") {
      DESKTOP.addListener(onBreakpointChange);
    }

    ensureOne();
  }

  function initAbout(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(".about-wrapper").forEach(initWrapper);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAbout(event.target);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAbout();
    });
  } else {
    initAbout();
  }
})();